import { Itechnology } from '../../types/shared.types';
import * as type from '../ActionTypes';

export function setTechnologyAction(value: string) {
  return {
    type: type.SET_TECHNOLOGY_NAME,
    name: value
  };
}
export function clearTechnologyAction() {
  return {
    type: type.CLEAR_TECHNOLOGY_NAME
  };
}
/**
 *
 * Technology Fetch and Set Actions Only
 */

export function getAllTechnologies() {
  return {
    type: type.GET_ALL_TECHNOLOGIES
  };
}

export function getAllTechnologiesSuccess(technologies: Itechnology[]) {
  return {
    type: type.GET_ALL_TECHNOLOGIES_SUCCESS,
    payload: technologies
  };
}

export function getAllTechnologiesFailure(error: any) {
  return {
    type: type.GET_ALL_TECHNOLOGIES_FAILURE,
    payload: error
  };
}
